import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';

import { CURRENCIES } from '../../constants';
import I18nLink from '../I18nLink';
import { getPriceInCurrency, formatPrice } from 'utils';

import './BikeCardPrice.css';

const BikeCardPrice = ({
  t,
  average,
  currency: currencyProps,
  href,
  bike,
  onClick: onClickProps
}) => {
  const price = getPriceInCurrency(bike.price, currencyProps);
  const salesPrice = getPriceInCurrency(bike.salesPrice, currencyProps);
  const averagePrice = getPriceInCurrency(bike.averagePrice, currencyProps);

  const currency = CURRENCIES.find(c => c.value === currencyProps);
  const symbol = currency && currency.symbol;

  const onClick = (event) => {
    event.preventDefault();
    onClickProps(bike);
  };

  const buttonProps = {
    bsStyle: 'success',
    block: true,
    onClick
  };

  if (href) {
    buttonProps.as = I18nLink;
    buttonProps.href = href;
  }

  return (
    <div className="bike-card-price-block">
      <span className="bike-card-price">
        {!average && (
          <span>
            {symbol} {formatPrice(salesPrice)}
            <span className="bike-card-price-old">
              {symbol} {formatPrice(price)}
            </span>
          </span>
        )}

        {!!average && (
          <span>
            {symbol} {formatPrice(averagePrice)}
          </span>
        )}
      </span>

      <ul className="bike-card-advantages-list">
        <li>{t('Best price guaranteed')}</li>
        <li>{t('Free cancellation')}</li>
        <li>{t('All taxes and fees included')}</li>
      </ul>

      <div>
        <Button {...buttonProps}>
          {t('More info and booking')}
        </Button>

        <div className="bike-card-price-block-notice">
          {t('Rental terms and extra services will be on the next step')}
        </div>
      </div>
    </div>
  );
};

BikeCardPrice.propTypes = {
  t: PropTypes.func.isRequired,
  average: PropTypes.bool,
  bike: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default translate(['search', 'translation'])(BikeCardPrice);



// WEBPACK FOOTER //
// ./src/widgets/BikeCard/BikeCardPrice.js